import React from 'react';
import './HeroMinhasIniciativasElbb.scss';

export const HeroMinhasIniciativasElbb: React.FC = () => {
  return (
    <div className="hero-minhas-iniciativas-elbb" role="banner" aria-label="Minhas iniciativas no Prêmio ELBB">
      <div className="hero-minhas-iniciativas-elbb__content">
        <h1 className="hero-minhas-iniciativas-elbb__title" tabIndex={0}>
          <span className="hero-minhas-iniciativas-elbb__title--highlight">Minha iniciativas</span> no{' '}
          <span className="hero-minhas-iniciativas-elbb__title--bold">Prêmio ELBB</span>
        </h1>
        <p className="hero-minhas-iniciativas-elbb__subtitle" tabIndex={0}>
          Confira aqui todas as suas iniciativas<br />inscritas
        </p>
      </div>
    </div>
  );
};
